<template>
  <div class="formGroup" :data-layout="layout">
    <div class="formGroup__body">
      <input type="text" v-show="false" v-validate:month="validation" :name="monthName" :value="month">
      <input type="text" v-show="false" v-validate:year="validation" :name="yearName" :value="year">

      <form-label-fes :label="label"></form-label-fes>
      <div class="cardExpireInput">
        <div class="cardExpireInput__select">
          <select
            ref="input"
            class="formControl cardExpireInput__input"
            v-model="month"
            @change="update"
            :data-error="errors.has(monthName)">
            <option v-for="option in months" :key="option.value">{{ option.text }}</option>
          </select>
        </div>
        <span>月</span>
        <div class="cardExpireInput__select">
          <select
            ref="input"
            class="formControl cardExpireInput__input"
            v-model="year"
            @change="update"
            :data-error="errors.has(yearName)">
            <option v-for="option in years" :value="option.value" :key="option.value">20{{ option.text }}</option>
          </select>
        </div>
        <span>年</span>
      </div>
    </div>
    <div class="formGroup__footer">
      <p class="formGroup__errorMessage" v-show="errors.has(monthName) || errors.has(yearName)">こちらの項目は入力必須です。</p>
      <slot></slot>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import mixin from './mixin'

const prependZero = val => (val >= 10 ? `${val}` : `0${val}`)

const years = () => {
  /**
   * テストカード有効期限が2035のためstg, devでは今年から30年の範囲
   */
  const range = /dev|staging/.test(location.host) ? 30 : 10
  const now = parseInt(moment().format('YY'), 10)
  const options = []
  for (let i = 0; i <= range; i++) {
    options.push({
      text: prependZero(i + now),
      value: prependZero(i + now)
    })
  }
  return options
}

const months = () => {
  const options = []
  for (let i = 1; i <= 12; i++) {
    options.push({
      text: prependZero(i),
      value: prependZero(i)
    })
  }
  return options
}

export default {
  name: 'form-credit-expire-fes',
  mixins: [mixin],
  data() {
    return {
      month: '01',
      year: '18',
      months: months(),
      years: years()
    }
  },
  props: {
    monthName: { type: String },
    yearName: { type: String }
  },
  mounted() {
    this.$emit('input', {
      year: this.year,
      month: this.month
    })
  },
  methods: {
    update($event) {
      this.$emit('input', {
        year: this.year,
        month: this.month
      })
    }
  }
}</script>

<style lang="scss" scoped>
.cardExpireInput {
  display: flex;
  align-items: center;
  &__input {
    width: 120px;
    border: 1px solid #C5C5C4;
    border-radius: 6px;
    background: #fff;
    height: 44px;
    padding: 14px 12px;
    font-size: 15px;
    line-height: 1;
  }

  &__select {
    position: relative;
    background: #fff;
    border-radius: 6px;

    select {
      position: relative;
      z-index: 1;
      background:transparent;
      &[data-error="true"] {
        border: 1px solid #EB2000;
      }
    }

    &::before {
      content: "";
      position: absolute;
      width: 12px;
      height: 12px;
      border-right: 2px solid #C5C5C4;
      border-bottom: 2px solid #C5C5C4;
      transform: rotate(45deg);
      top: 50%;
      margin-top: -8px;
      right: 8px;
    }

  }
  span {
    margin-right: 8px;
    margin-left: 8px;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/uFes/components/FormCreditExpireFes.vue